<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Categorias Financeiras</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/financas">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Gerenciamento de categorias de receitas e despesas
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">

                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    @if(selection.hasValue()) {
                    <button mat-menu-item [disabled]="algumSelecionadoTemSubcategorias()"
                        [matTooltip]="algumSelecionadoTemSubcategorias() ? 'Não é possível excluir: algum item selecionado possui subcategorias' : ''"
                        (click)="abrirModalExcluir()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir selecionados</span>
                    </button>
                    <button mat-menu-item (click)="abrirModalMover()">
                        <mat-icon class="material-symbols-outlined">drive_file_move</mat-icon>
                        <span>Mover categorias selecionadas</span>
                    </button>
                    } @else {
                    <button mat-menu-item (click)="exportarCategorias()">
                        <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
                        <span>Exportar categorias</span>
                    </button>
                    <button mat-menu-item (click)="importarCategorias()">
                        <mat-icon class="material-symbols-outlined">file_download</mat-icon>
                        <span>Importar categorias</span>
                    </button>
                    }
                </mat-menu>

                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/financas/categorias/cadastrar">
                    <span class="material-symbols-outlined">add</span>
                    Nova Categoria
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Pesquise por nome da categoria">

                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(_dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_flatDataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox variation-checkbox">
                    <div class="checkbox-indent" [style.padding-left.px]="row.level * 20">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? toggleSelection(row.data) : null" [checked]="selection.isSelected(row.data)"
                            [aria-label]="checkboxLabel(row.data)">
                        </mat-checkbox>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
                <td mat-cell *matCellDef="let row">
                    @if(row.isVariation) {
                    <span class="variation-indent" [style.padding-left.px]="row.level * 32">
                        <mat-icon class="variation-icon">subdirectory_arrow_right</mat-icon>
                        {{row.data.categoriaFinanceira.descricao}}
                        @if(row.data.subcategorias?.length) {
                        <span class="badge-variacoes" (click)="toggleRow(row); $event.stopPropagation()">
                            {{row.data.subcategorias.length}} Subcategorias
                            <mat-icon class="icon-expand">{{expandedElements.has(row.data) ? 'expand_less' :
                                'expand_more'}}</mat-icon>
                        </span>
                        }
                    </span>
                    } @else {
                    {{row.data.categoriaFinanceira.descricao}}
                    @if(row.data.subcategorias?.length) {
                    <span class="badge-variacoes" (click)="toggleRow(row); $event.stopPropagation()">
                        {{row.data.subcategorias.length}} Subcategorias
                        <mat-icon class="icon-expand">{{expandedElements.has(row.data) ? 'expand_less' :
                            'expand_more'}}</mat-icon>
                    </span>
                    }
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="tipoCategoriaFinanceira">
                <th mat-header-cell *matHeaderCellDef> Tipo (Receita/Despesa) </th>
                <td mat-cell *matCellDef="let row">
                    @if(row.data.tipoCategoriaFinanceira) {
                    <span class="status-badge "
                        [ngClass]="{'badge-verde': row.data.tipoCategoriaFinanceira.idTipoCategoriaFinanceira === 1, 'badge-vermelho': row.data.tipoCategoriaFinanceira.idTipoCategoriaFinanceira === 2}">
                        {{row.data.tipoCategoriaFinanceira.descricao}}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="tipoCategoriaDre">
                <th mat-header-cell *matHeaderCellDef> Grupo DRE </th>
                <td mat-cell *matCellDef="let row"> {{row.data.tipoCategoriaDre?.descricao}} </td>
            </ng-container>

            <ng-container matColumnDef="isAtivo">
                <th mat-header-cell *matHeaderCellDef> Situação </th>
                <td mat-cell *matCellDef="let row">
                    @if(row.data.categoriaFinanceira.isAtivo) {
                    <span class="status-badge badge-verde">Ativo</span>
                    } @else {
                    <span class="status-badge badge-cinza">Inativo</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                <td mat-cell *matCellDef="let row" class="text-center">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações"
                        (click)="$event.stopPropagation()">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/categorias/cadastrar', {idCategoriaFinanceira: row.data.categoriaFinanceira.idCategoriaFinanceira}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item [disabled]="hasSubcategorias(row.data)"
                            [matTooltip]="hasSubcategorias(row.data) ? 'Não é possível excluir: possui subcategorias' : ''"
                            (click)="abrirModalExcluir(row.data)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.variation-row]="row.isVariation"
                [class.parent-expanded-row]="!row.isVariation && expandedElements.has(row.data)"
                (click)="toggleRow(row)" [style.cursor]="row.data.subcategorias?.length ? 'pointer' : 'default'">
            </tr>
        </table>


        <!-- View Mobile -->
        <div class="mobile-view">
            @for (cat of _dataSource.data; track cat.categoriaFinanceira.idCategoriaFinanceira) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(cat)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? toggleSelection(cat) : null"
                            [checked]="selection.isSelected(cat)" color="primary">
                        </mat-checkbox>
                        <div class="d-flex flex-column">
                            <span class="text-bold">{{cat.categoriaFinanceira.descricao}}</span>
                            <small>{{cat.tipoCategoriaFinanceira.descricao}}</small>
                        </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/categorias/cadastrar', {idCategoriaFinanceira: cat.categoriaFinanceira.idCategoriaFinanceira}]">Editar</button>
                        <button mat-menu-item [disabled]="hasSubcategorias(cat)"
                            (click)="abrirModalExcluir(cat)">Excluir</button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    <div class="row">
                        <div class="col-6 mb-2">
                            <small class="d-block">DRE</small>
                            <span class="text-bold">{{ cat.tipoCategoriaDre.descricao }}</span>
                        </div>
                        <div class="col-6 mb-2">
                            <small class="d-block">Status</small>
                            <span>{{ cat.categoriaFinanceira.isAtivo ? 'Ativo' : 'Inativo' }}</span>
                        </div>
                    </div>

                    @if(cat.subcategorias?.length) {
                    <div class="mt-3">
                        <button mat-button (click)="toggleRow({data: cat, isVariation: false, level: 0})"
                            class="w-100 text-center">
                            <mat-icon>{{expandedElements.has(cat) ? 'expand_less' : 'expand_more'}}</mat-icon>
                            {{$any(cat).subcategorias.length}} Subcategorias
                        </button>

                        @if(expandedElements.has(cat)) {
                        <ng-container
                            *ngTemplateOutlet="mobileSubcategorias; context: { $implicit: cat.subcategorias, level: 1 }">
                        </ng-container>
                        }
                    </div>
                    }
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="20"></mat-spinner>
                }
                @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>

        } @else if(_isLoading === true && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list [title]="'Nenhuma categoria encontrada'"
            [subTitle]="'Tente alterar os filtros de busca ou crie uma nova categoria.'"></app-empty-list>
        }
    </div>
</div>

<!-- Template recursivo para subcategorias mobile -->
<ng-template #mobileSubcategorias let-subcategorias let-level="level">
    <div class="variations-mobile-list" [style.margin-left.px]="level * 16">
        @for(sub of subcategorias; track sub.categoriaFinanceira.idCategoriaFinanceira) {
        <div class="variation-item mb-3" [class.selected-card]="selection.isSelected(sub)">
            <div class="d-flex justify-content-between align-items-start">
                <div class="d-flex align-items-center gap-2">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleSelection(sub) : null"
                        [checked]="selection.isSelected(sub)" color="primary">
                    </mat-checkbox>
                    <div class="d-flex flex-column">
                        <strong>{{sub.categoriaFinanceira.descricao}}</strong>
                        <span>{{sub.tipoCategoriaFinanceira?.descricao}}</span>
                    </div>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menuSubMobile" class="scale-08">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuSubMobile="matMenu">
                    <button mat-menu-item
                        [routerLink]="['/configuracoes/financas/categorias/cadastrar', {idCategoriaFinanceira: sub.categoriaFinanceira.idCategoriaFinanceira}]">Editar</button>
                    <button mat-menu-item [disabled]="hasSubcategorias(sub)"
                        (click)="abrirModalExcluir(sub)">Excluir</button>
                </mat-menu>
            </div>
            <div class="d-flex justify-content-between small mt-1 ps-5">
                <span>{{sub.tipoCategoriaDre?.descricao}}</span>
            </div>

            @if(sub.subcategorias?.length) {
            <div class="mt-2">
                <button mat-button class="w-100 text-center mb-3"
                    (click)="toggleRow({data: sub, isVariation: true, level: level})">
                    <mat-icon>{{expandedElements.has(sub) ? 'expand_less' : 'expand_more'}}</mat-icon>
                    {{sub.subcategorias.length}} Subcategorias
                </button>
                @if(expandedElements.has(sub)) {
                <ng-container
                    *ngTemplateOutlet="mobileSubcategorias; context: { $implicit: sub.subcategorias, level: level + 1 }">
                </ng-container>
                }
            </div>
            }
        </div>
        }
    </div>
</ng-template>
